var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8204 2C21.0504 2.35 20.2204 2.58 19.3604 2.69C20.2404 2.16 20.9204 1.32 21.2404 0.31C20.4104 0.81 19.4904 1.16 18.5204 1.36C17.7304 0.5 16.6204 0 15.3604 0C13.0104 0 11.0904 1.92 11.0904 4.29C11.0904 4.63 11.1304 4.96 11.2004 5.27C7.64039 5.09 4.47039 3.38 2.36039 0.79C1.99039 1.42 1.78039 2.16 1.78039 2.94C1.78039 4.43 2.53039 5.75 3.69039 6.5C2.98039 6.5 2.32039 6.3 1.74039 6C1.74039 6 1.74039 6 1.74039 6.03C1.74039 8.11 3.22039 9.85 5.18039 10.24C4.82039 10.34 4.44039 10.39 4.05039 10.39C3.78039 10.39 3.51039 10.36 3.25039 10.31C3.79039 12 5.36039 13.26 7.25039 13.29C5.79039 14.45 3.94039 15.13 1.92039 15.13C1.58039 15.13 1.24039 15.11 0.900391 15.07C2.80039 16.29 5.06039 17 7.48039 17C15.3604 17 19.6904 10.46 19.6904 4.79C19.6904 4.6 19.6904 4.42 19.6804 4.23C20.5204 3.63 21.2404 2.87 21.8204 2Z",
    fill: "#6D95FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.77d42d2c8cf5ac45a872f33e00c1f020.svg";
export { ForwardRef as ReactComponent };